export const LinkAgentModal: string = 'LinkAgentModal';
